const apiUrls = {
  login: '/customer/api/login',
  logout: '/customer/api/logout',
  signUp: '/customer/api/signUp',

  productSave: '/customer/api/product/save',
  clickTechVideo: '/customer/api/product/click-tech-video',
  productDelete(type, id) {
    return '/customer/api/product/' + type + '/' + id
  },

  productPriceWatch: '/customer/api/product/price-watch/save',
  deleteProductPriceWatch(id) {
    return '/customer/api/product/price-watch/' + id
  },

  productSimilarAlerts: '/customer/api/product/similar-alert/save',
  prodocutSimilarAlertsDelete(type, id) {
    return '/customer/api/product/similar-alert/' + type + '/' + id
  },

  productSearchSave: '/customer/api/search/save',
  deleteSearch(id) {
    return `/customer/api/search/${id}`
  },

  self: '/customer/api/self',
  sendLfEvent: '/customer/api/sendLfEvent',

  usedProductServiceHistory(serialNumber) {
    const encodedSerialNumber = encodeURIComponent(serialNumber); // URL-encode the serial number
    return `/api/used/service-history?serial_number=${encodedSerialNumber}`;
  },

  blogsRelatedItems(postId) {
    return `/api/blogs/${postId}/related-items`;
  },

  youtubeRelatedItems(id) {
    return `/api/blog/video/${id}/related-items`;
  }
};

export default apiUrls



// WEBPACK FOOTER //
// ./resources/js/store/apiUrls.js